// extracted by css-extract-rspack-plugin
export default {"wrapper":"searchbar-module__wrapper___IN6hq","field":"searchbar-module__field___dPdc7","discord":"searchbar-module__discord____d7Zc"};